import { useMemo } from "react";
import { useTournamentContext } from "../../../../hook/context";
import * as C from "../base/style";
import {
  EditTournamentCheckBox,
  EditTournamentCheckBoxWrapper,
} from "../../style";

const EditTournamentParticipation = () => {
  const {
    buyIn,
    setBuyIn,
    buyInChip,
    setBuyInChip,
    reBuyIn,
    setReBuyIn,
    reBuyInChip,
    setReBuyInChip,
    addOn,
    setAddOn,
    adOnChip,
    setAdOnChip,
    isFreezeOut,
    setIsFreezeOut,
  } = useTournamentContext();

  const formatNumber = (value: string) => {
    return +value.replace(/[^0-9]/g, "");
  };

  const priceList = useMemo(() => {
    if (isFreezeOut) {
      return [
        {
          name: "바이인",
          price: buyIn,
          setPrice: setBuyIn,
          chip: buyInChip,
          setChip: setBuyInChip,
        },
      ];
    }

    return [
      {
        name: "바이인",
        price: buyIn,
        setPrice: setBuyIn,
        chip: buyInChip,
        setChip: setBuyInChip,
      },
      {
        name: "리바인",
        price: reBuyIn,
        setPrice: setReBuyIn,
        chip: reBuyInChip,
        setChip: setReBuyInChip,
      },
      {
        name: "애드온",
        price: addOn,
        setPrice: setAddOn,
        chip: adOnChip,
        setChip: setAdOnChip,
      },
    ];
  }, [adOnChip, addOn, buyIn, buyInChip, reBuyIn, reBuyInChip, isFreezeOut]);

  return (
    <C.EditTournamentBaseWrapper>
      <C.EditTournamentBaseContent>
        <EditTournamentCheckBoxWrapper $weight="500">
          <EditTournamentCheckBox isMobile={true}>
            <input
              type="checkbox"
              checked={isFreezeOut}
              onChange={(e) => setIsFreezeOut(e.target.checked)}
            />
            {isFreezeOut && (
              <img src="/image-web/tournament/checked-icon.svg" alt="checked" />
            )}
          </EditTournamentCheckBox>
          <div className="name">프리즈 아웃</div>
        </EditTournamentCheckBoxWrapper>
      </C.EditTournamentBaseContent>

      {priceList.map((p, i) => (
        <C.EditTournamentBaseContent key={i}>
          <div className="title">{p.name}</div>
          <C.EditTournamentInputBox>
            <div className="name">금액</div>
            <input
              value={p.price.toLocaleString()}
              onChange={(e) => p.setPrice(formatNumber(e.target.value))}
            />
            <span>원</span>
          </C.EditTournamentInputBox>
          <C.EditTournamentInputBox>
            <div className="name">칩</div>
            <input
              value={p.chip.toLocaleString()}
              onChange={(e) => p.setChip(formatNumber(e.target.value))}
            />
            <span>칩</span>
          </C.EditTournamentInputBox>
        </C.EditTournamentBaseContent>
      ))}
    </C.EditTournamentBaseWrapper>
  );
};

export default EditTournamentParticipation;
